export enum EIntervalType {
  WEEKDAY = 'weekday', //monday, tuesday, wednesday, thursday, friday, saturday, sunday
  UNIT = 'unit', // 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60 //Used in eachNDays, eachNMinutes, eachNHours
  DATE_DAY = 'dateDay', //01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
  DATE = 'date', //MM-DD //used in yearly type
}

export enum EWeekdays {
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday',
}

export enum EFrequencyType {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  HOURLY = 'hourly',
}

export enum EEmitterType {
  WEBHOOK = 'webhook',
  SOCKET = 'socket',
}

export enum EOnEmitActions {
  WAIT_FOR_RESPONSE = 'WAIT_FOR_RESPONSE',
  MARK_AS_COMPLETE = 'MARK_AS_COMPLETE',
}

export enum EMode {
  SINGLE_EXECUTION = 'SINGLE_EXECUTION',
  REPETITIVE = 'REPETITIVE',
  CONFIGURE_LATER = "CONFIGURE_LATER"
}

export enum EStatus {
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  CANCELED = 'CANCELED',
  ERROR = 'ERROR',
}

export enum ESchedulerMode {
  BUFFERED = "buffered",
  FIXED = "fixed",
}

